import type { Story } from '@/store/story-types'

export const FAN_CLUB_STORE_STORY: Story = {
  id: 'fan-club-store',
  name: 'Fan Club Store',
  narrative:
    'A creator fan club store featuring limited edition drops, membership tiers, and exclusive merchandise for dedicated fans.',
  goals: [
    'Showcase limited edition drops with urgency',
    'Present membership tiers and benefits',
    'Enable fans to browse and purchase exclusive merch',
    'Provide smooth cart-to-checkout experience',
  ],
  lifecycle: 'building',
  pages: [
    {
      id: 'pg-home',
      title: 'Home',
      order: 0,
      status: 'draft',
      elementCount: 4,
      linkedPageId: 'home',
      description:
        'Fan club landing with hero banner, limited drops section, and membership tiers',
      blockRef: { category: 'store', blockId: 'fan-hero' },
    },
    {
      id: 'pg-product-detail',
      title: 'Product Detail',
      order: 1,
      status: 'draft',
      elementCount: 1,
      linkedPageId: 'product-detail',
      description: 'Product detail page for fan club exclusive items',
      blockRef: { category: 'store', blockId: 'fan-product-detail' },
    },
    {
      id: 'pg-cart',
      title: 'Cart',
      order: 2,
      status: 'draft',
      elementCount: 1,
      linkedPageId: 'cart',
      description: 'Shopping cart with fan club items and totals',
      blockRef: { category: 'store', blockId: 'fan-cart-view' },
    },
    {
      id: 'pg-checkout',
      title: 'Checkout',
      order: 3,
      status: 'draft',
      elementCount: 1,
      linkedPageId: 'checkout',
      description: 'Checkout form with shipping, payment, and order summary',
      blockRef: { category: 'store', blockId: 'fan-checkout' },
    },
  ],
  bddScenarios: [
    {
      id: 'bdd-browse-drops',
      name: 'Browse Limited Drops',
      steps: [
        { type: 'given', text: 'the fan is on the home page' },
        { type: 'when', text: 'the page loads' },
        {
          type: 'then',
          text: 'the hero banner, limited drops section, and membership tiers are visible',
          linkedPageId: 'home',
        },
      ],
    },
    {
      id: 'bdd-view-product',
      name: 'View Drop Detail',
      steps: [
        { type: 'given', text: 'the fan is browsing limited drops' },
        { type: 'when', text: 'the fan taps on a drop item' },
        {
          type: 'then',
          text: 'the product detail page shows item images, price, availability, and description',
          linkedPageId: 'product-detail',
        },
      ],
    },
    {
      id: 'bdd-add-to-cart',
      name: 'Add Drop to Cart',
      steps: [
        { type: 'given', text: 'the fan is viewing a product detail page' },
        { type: 'when', text: 'the fan taps "Add to Cart"' },
        {
          type: 'then',
          text: 'the item is added to the cart and the cart count updates',
          linkedPageId: 'cart',
        },
      ],
    },
    {
      id: 'bdd-checkout',
      name: 'Complete Purchase',
      steps: [
        { type: 'given', text: 'the fan has items in the cart' },
        { type: 'when', text: 'the fan proceeds to checkout and submits payment' },
        {
          type: 'then',
          text: 'the order is confirmed and a success message is shown',
          linkedPageId: 'checkout',
        },
      ],
    },
    {
      id: 'bdd-membership',
      name: 'View Membership Tiers',
      steps: [
        { type: 'given', text: 'the fan is on the home page' },
        { type: 'when', text: 'the fan scrolls to the membership section' },
        {
          type: 'then',
          text: 'the membership tiers with benefits and pricing are displayed',
          linkedPageId: 'home',
        },
      ],
    },
  ],
}
